import { ChatRoomAddParticipantsComponent } from './chat-room-add-participants.component';

export default angular
  .module('sfMobile.components.chat-room-add-participants', [
    'sfMobile.components.content',
    'sfMobile.components.button-header-close',
  ])
  .component('sfChatRoomAddParticipants', ChatRoomAddParticipantsComponent)
  .name;
